import React, { useEffect } from "react";
import { concentratorType } from "../../../../../../shared_lsi_sg/concentratorData";
import ConcentratorSelectors from "./templateConcentratorCustom/ConcentratorSelectors";
import ConcentratorCorePortable from "./templateConcentratorCustom/core/ConcentratorCorePortable";
import ConcentratorCoreTransportable from "./templateConcentratorCustom/core/ConcentratorCoreTransportable";
import ConcentratorCoreOtherInfo from "./templateConcentratorCustom/core/ConcentratorCoreOtherInfo";
import VoxiSudFooter from "./templateConcentratorCustom/VoxiSudFooter";

export function TemplateConcentratorPortableVoxiSud({ dataForm, changeValue, errors, setData, isSubmit }) {
  const legacyValidUntil =
    dataForm?.["fixed.validUntil"]
    || dataForm?.["portable.validUntil"]
    || dataForm?.["transportable.validUntil"]
    || dataForm?.fixed?.validUntil
    || dataForm?.portable?.validUntil
    || dataForm?.transportable?.validUntil;

  const changeValueHandler = (data) => {
    if (data.name === "concentratorType") {
      const newType = data.value;
      const newData = { ...dataForm, concentratorType: newType };
      if (newType === concentratorType.portable) {
        Object.keys(newData).forEach((key) => {
          if (key.startsWith("transportable.")) {
            delete newData[key];
          }
        });
      } else if (newType === concentratorType.transportable) {
        Object.keys(newData).forEach((key) => {
          if (key.startsWith("portable.")) {
            delete newData[key];
          }
        });
      }
      setData(newData);
      return;
    }
    changeValue && changeValue(data);
  };

  useEffect(() => {
    if (!dataForm?.validUntil && legacyValidUntil) {
      changeValue && changeValue({ name: "validUntil", value: legacyValidUntil });
    }
  }, [changeValue, dataForm?.validUntil, legacyValidUntil]);

  const selectedType = dataForm?.concentratorType;

  return (
    <>
      <ConcentratorSelectors
        dataForm={dataForm}
        changeValue={changeValueHandler}
        errors={errors}
        isSubmit={isSubmit}
        templateType="portable"
        hideValidUntil={true}
      />

      {selectedType === concentratorType.portable && (
        <>
          <ConcentratorCorePortable
            isSubmit={isSubmit}
            errors={errors}
            changeValue={changeValue}
            dataForm={dataForm}
            setData={setData}
            prescriptionTitle="Portatile"
          />
          <ConcentratorCoreOtherInfo
            isSubmit={isSubmit}
            errors={errors}
            changeValue={changeValue}
            dataForm={dataForm}
            setData={setData}
          />
        </>
      )}

      {selectedType === concentratorType.transportable && (
        <>
          <ConcentratorCoreTransportable
            isSubmit={isSubmit}
            errors={errors}
            changeValue={changeValue}
            dataForm={dataForm}
            setData={setData}
            prescriptionTitle="Trasportabile"
          />
          <ConcentratorCoreOtherInfo
            isSubmit={isSubmit}
            errors={errors}
            changeValue={changeValue}
            dataForm={dataForm}
            setData={setData}
          />
        </>
      )}

      <VoxiSudFooter
        dataForm={dataForm}
        changeValue={changeValue}
        errors={errors}
        isSubmit={isSubmit}
      />
    </>
  );
}
